import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 标记所有消息为已读
 * @returns {Promise}
 */
export const mark_all_read = () => {
  // 后端使用PUT方法，无参数
  return api.put(`${ApiEndpointConstants.MARK_ALL_READ}`, {});
};

